<ng-container *ngIf="isOldDesign; else isNewDS">
  <button role="button" aria-label="like an item" class="likeSnippet" [ngClass]="className" (click)="likeItems()">
    <div class="likeSnippet__icon" [class.liked]="isLiked">
      <div class="likeSnippet__icon__heart" [ngClass]="{'likeSnippet__icon__heart--full': isLiked}"></div>
    </div>
    <div *ngIf="!isProductLike" class="likeSnippet__count">{{ likeCount }}</div>
    <div *ngIf="isBrandLike || isProductLike" class="likeSnippet__textCount" i18n="@@LIKE.I_LIKE">
      Like {{ likeCount }}
    </div>
  </button>
</ng-container>

<ng-template #isNewDS>
  <button role="button" aria-label="like an item" class="likeSnippet likeSnippet--vertical" (click)="likeItems()">
    <div class="likeSnippet__icon" [class.liked]="isLiked">
      <div class="likeSnippet__icon__heart"></div>
      <div class="vc-text-xs likeSnippet--vertical__count">
        <span>{{ likeCount }}</span>
      </div>
    </div>
  </button>
</ng-template>
